import {ACTION_TYPES} from "../consts";
import {AnalyticsService} from "../../third-party-services/analytics/analytics-service";
import {AnalyticsEventHandler} from "../../infrastructure/handlers/analytics-event-handler";
import {PoweredByDisplayEvent} from "../models/events/powered-by.display-event";

export class PoweredByDisplayEventHandler extends AnalyticsEventHandler {
  type = ACTION_TYPES.poweredByDisplay;

  static injectables = [AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.eventType = PoweredByDisplayEvent;
  }
}
